// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9a173375","455":"2144e6e5"}[chunkId] + ".chunk.js";
};